import React from "react";

const Logo = ({ className = "" }) => (
  <>
    {/* Light Mode */}
    <img
      src="/emptymiles.png"
      alt="EmptyMiles Logo"
      className={`block dark:hidden ${className}`}
    />

    {/* Dark Mode */}
    <img
      src="/emptymiles-dark.png"
      alt="EmptyMiles Logo"
      className={`hidden dark:block ${className}`}
    />
  </>
);

export default React.memo(Logo);
